module.exports = __webpack_public_path__ + "MP.png?9961559d11824ceca61753675182cba3";